var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonOutline = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 17.818c3.594 0 7.041 1.213 9.583 3.372 1.899 1.614 3.175 3.658 3.7 5.862.294 1.236-.743 2.281-1.99 2.281H4.707c-1.248 0-2.285-1.045-1.99-2.281.524-2.204 1.802-4.248 3.7-5.862 2.542-2.159 5.989-3.372 9.583-3.372ZM19.53 22a.5.5 0 0 0-.5.5v1.667a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V22.5a.5.5 0 0 0-.5-.5h-3ZM16 4c3.118 0 5.646 2.578 5.646 5.758S19.118 15.516 16 15.516c-3.119 0-5.647-2.579-5.647-5.758C10.353 6.578 12.881 4 16 4Z"
})));
SvgPersonOutline.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonOutline);
export default ForwardRef;